import { InvoiceStatusType } from '@viewbid/ts-angular-client';

export const InvoiceStatus: Readonly<{
    PendingBuyerReview: InvoiceStatusType;
    RequiresShippingQuote: InvoiceStatusType;
    PendingShippingReview: InvoiceStatusType;
    PendingBuyerShippingReview: InvoiceStatusType;
    AwaitingAssembly: InvoiceStatusType;
    AwaitingAssemblyReview: InvoiceStatusType;
    AwaitingPickup: InvoiceStatusType;
    Completed: InvoiceStatusType;
}> = {
    PendingBuyerReview: InvoiceStatusType.PendingBuyerReview,
    RequiresShippingQuote: InvoiceStatusType.RequiresShippingQuote,
    PendingShippingReview: InvoiceStatusType.PendingShippingQuoteReview,
    PendingBuyerShippingReview:
        InvoiceStatusType.PendingBuyerShippingQuoteReview,
    AwaitingAssembly: InvoiceStatusType.AwaitingAssembly,
    AwaitingAssemblyReview: InvoiceStatusType.PendingAssemblyReview,
    AwaitingPickup: InvoiceStatusType.AwaitingPickup,
    Completed: InvoiceStatusType.Completed,
};
